import config from '../config';
import { useMemo } from 'react';

export default class Utils {
  static mergeClasses = (
    ...classNames: (string | undefined | Record<string, boolean | undefined>)[]
  ): string => {
    return classNames
      .map((value) => {
        if (typeof value !== 'string' && value !== undefined) {
          const v: Record<string, boolean | undefined> = value;
          const s = Object.entries(v)
            .filter((e) => e[1])
            .map((e) => e[0])
            .join(' ');
          return s.trim() === '' ? undefined : s.trim();
        } else {
          return value;
        }
      })
      .filter((value) => !!value)
      .join(' ');
  };

  static removeNull = <T>(value: T): any => {
    if (value !== null && value !== undefined && typeof value === 'object') {
      return Object.fromEntries(
        Object.entries(value)
          .map((v) => [v[0], Utils.removeNull(v[1])])
          .filter((v) => v[1] !== null),
      );
    }
    return value as any;
  };

  static getFileUrl(path?: string): string | undefined {
    if (!path) return undefined;
    return `${config.api.fileUrl}${path}`;
  }

  static useOmitFields(value: any, ...fields: string[]) {
    return useMemo(() => {
      const val = { ...value };
      fields.forEach((f) => delete val[f]);
      return val;
    }, [value, fields]);
  }

  static mergeArrays<T>(current: T[], newValues: T[], idExtractor: (t: T) => string | number): T[] {
    const cur = [...current];
    for (const n of newValues) {
      const index = cur.findIndex((value) => idExtractor(value) === idExtractor(n));
      if (index === -1) {
        cur.push(n);
      } else {
        cur[index] = n;
      }
    }
    return cur;
  }
}
